<template>
    <b-col md="12" sm="8">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <b-form v-on:submit.prevent="onSubmit">
            <h1>Meus Dados</h1>
            <b-row>
              <b-col cols="8">
                <b-form-group label="Nome Social:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model.trim="$v.form.nome_social.$model"
                                  :state="chkState('nome_social')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome Social é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="CPF:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="CPF"
                                  autocomplete="cpf"
                                  v-model="form.cpf" disabled/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="8">
                <b-form-group label="Nome Completo:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model.trim="form.nome" disabled/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Perfil:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model.trim="form.perfil" disabled/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                  <b-form-group label="UF:">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text"
                                    class="form-control"
                                    v-model.trim="form.uf" disabled />
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="8">
                  <b-form-group label="Situação do Cadastro:">
                    <b-input-group class="mb-3">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                      <b-form-input type="text"
                                    class="form-control"
                                    v-model.trim="form.status" disabled/>
                    </b-input-group>
                  </b-form-group>
                </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group label="E-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  v-model.trim="$v.form.email.$model"
                                  :state="chkState('email')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Confirme o e-mail:">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  id="confirmar-email"
                                  placeholder="Confirme o e-mail"
                                  oncut="return false"
                                  onpaste="return false"
                                  autocomplete="confirme-email"
                                  v-model.trim="$v.form.confirmaEmail.$model"
                                  :state="chkState('confirmaEmail')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback8">Este é um campo obrigatório, e deve ser correspondente ao campo e-mail.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <p>Clique <a href="javascript:return" @click="navigate('/ficha')">aqui</a> para visualizar seu cadastro completo.</p>
                    <p>Em caso de dúvidas ou caso queira alterar alguma informação, por favor, entre em contato pelo e-mail <strong>se.conanda@mdh.gov.br</strong>.</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-checkbox
                          v-model="$v.form.termo_01.$model"
                          :options="options"
                          name="checkbox-validation"
                          >Lei Geral e Proteção de Dados - Autorizo o tratamnto dos dados para fins estátisticos.
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-checkbox
                          v-model="$v.form.termo_02.$model"
                          :options="options"
                          name="checkbox-validation"
                          >Autorizo a divulgação do meu nome, estando ciente de que o conteúdo da XI CNDCA poderá ser disponibilizado em quaiquer outros meios, inclusive sendo dispinibilizada para acesso público.
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-checkbox
                          v-model="$v.form.termo_03.$model"
                          :options="options"
                          name="checkbox-validation">Li e estou de acordo com o <a href="javascript:return" @click="abrirDocumento('2.pdf')">Regimento Interno</a> da XI Conferência Nacional dos Direitos da Nacional dos Direitos das Crianças e dos Adolescentes.
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <br>
              <b-row>
                  <b-col cols="12">
                      <p>Clique aqui para acessar a guia do participante.</p>
                  </b-col>
              </b-row>
          </b-form>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-row>
            <b-col v-if="!loading" md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
                <i class="fa fa-pencil"></i>&nbsp;
                <span>Salvar</span>
              </b-button>
            </b-col>
            <b-col v-else md="3" offset-md="3">
              <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
                <b-spinner small type="grow"></b-spinner>Salvando...
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="primary" v-on:click="loadModalSenha">
                <i class="fa fa-pencil"></i>&nbsp;
                <span>Alterar Senha</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
      <b-modal title="Alterar Senha" ok-title="Alterar" cancel-title="Cancelar" v-model="modalAlterarModalSenha" @ok="alterarSenha">
        <b-card-body>
          <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Senha Atual">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Senha"
                                  v-model.trim="form_alterar_senha.old_password"
                                  autocomplete="new-password"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Nova Senha">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Senha"
                                  v-model.trim="form_alterar_senha.senha"
                                  autocomplete="new-password"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Confirmar a Senha">
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Confirmar a Senha"
                                  v-model.trim="form_alterar_senha.confirmaSenha"
                                  autocomplete="new-password"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>
    </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, email, sameAs} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      nome_social: {
        required
      },
      email: {
        required,
        email
      },
      termo_01: {
        required
      },
      termo_02: {
        required
      },
      termo_03: {
        required
      },
      confirmaEmail: {
        required,
        email,
        sameAsEmail: sameAs('email')
      }
    }
  },
  created () {
    this.$store.dispatch('buscarEstadosPorRegiao')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      loading: false,
      form: {
        id: '',
        cpf: '',
        date: '',
        data_nascimento: '',
        nome: '',
        nome_social: '',
        status: null,
        perfil: '',
        foto: null,
        email: '',
        senha: '',
        uf: null,
        municipio: null,
        confirmaEmail: '',
        termo_01: false,
        termo_02: false,
        termo_03: false
      },
      form_alterar_senha: {
        old_password: '',
        senha: '',
        confirmaSenha: ''
      },
      options: [
        {value: true}
      ],
      disabled_cidades: true,
      disable_buttons: false,
      modalAlterarModalSenha: false,
      titulo_toast: 'Alerta!',
      salvarForm: false,
      todas_cidades: false
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    perfis () {
      return this.$store.state.perfil.lista
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  mounted () {
    this.loadUser(this.$route.params.id)
  },
  methods: {
    loadModalSenha () {
      this.modalAlterarModalSenha = true
    },
    loadUser (id) {
      Vue.http.get('api/usuario/meusDados').then(response => {
        let data = response.body.data

        this.form.id = data.id
        this.form.cpf = data.participante.cpf
        this.form.nome_social = data.participante.nome_social
        this.form.nome = data.participante.nome
        this.form.uf = data.participante.cidade_moradia.estado.sigla
        this.form.email = data.participante.email
        this.form.confirmaEmail = data.participante.email
        this.form.termo_01 = data.termo_01
        this.form.termo_02 = data.termo_02
        this.form.termo_03 = data.termo_03

        switch (data.participante.situacao) {
          case 'P':
            this.form.status = 'Pendente'
            break
          case 'C':
            this.form.status = 'Credenciado'
            break
          case 'R':
            this.form.status = 'Reprovado'
            break
          default:
            this.form.status = ''
            break
        }

        switch (data.participante.participacao) {
          case 'D':
            this.form.perfil = 'Delegado'
            break
          case 'C':
            this.form.perfil = 'Convidado/a'
            break
          case 'P':
            this.form.perfil = 'Palestrante'
            break
          case 'O':
            this.form.perfil = 'Observador'
            break
          case 'A':
            this.form.perfil = 'Equipe de apoio (organização, relatoria e outros)'
            break
          default:
            this.form.perfil = ''
            break
        }
      })
    },
    abrirDocumento (documento) {
      window.open(process.env.ROOT_API1 + 'documentos-apoio/' + documento, 'download_window')
    },
    uploadFoto (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.form.foto = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    salvar () {
      let form = this.$v.form
      let data = {
        nome_social: form.nome_social.$model,
        email: form.email.$model,
        termo_01: form.termo_01.$model,
        termo_02: form.termo_02.$model,
        termo_03: form.termo_03.$model
      }

      if (!data.termo_01 || !data.termo_02 || !data.termo_03) {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('É obrigatório aceitar todos os termos.', 'Alerta', 5000)
        return
      }

      this.loading = true
      Vue.http.put('api/usuario/alterarMeusDadosParticipante', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.loadUser()
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    alterarSenha () {
      let data = {
        old_password: this.form_alterar_senha.old_password,
        new_password: this.form_alterar_senha.senha,
        new_password_confirmation: this.form_alterar_senha.confirmaSenha
      }

      if (this.form_alterar_senha.old_passoword === '') {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Informe a sua senha atual!.', 'Alerta', 5000)
        return false
      }

      if (this.form_alterar_senha.senha === '' || this.form_alterar_senha.confirmaSenha === '') {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Informe a senha e a confirmação de senha!.', 'Alerta', 5000)
        return false
      }

      if (this.form_alterar_senha.senha !== this.form_alterar_senha.confirmaSenha) {
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
        miniToastr.error('Os campos senha e confirmação e senha devem ser iguais!.', 'Alerta', 5000)
        return false
      }

      this.loading = true
      Vue.http.post('api/usuario/alterarMinhaSenha', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
        this.loading = false
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/perfil/MeuPerfilParticipante.vue